export const WEB_SDK_TEST_ISSUES_CSV_HEADERS = {
	ISSUE_NO: 'Issue No.',
	DETECTION_TIME: 'Detection Time',
	CROSS_SCANS_ID: 'Cross Scans Id',
	FIRST_TIME_SEEN: 'First Time Seen',
	ISSUE_TYPE: 'Issue Type',
	SEVERITY: 'Severity',
	WCAG_TAGS: 'WCAG Tags',
	SUMMARY: 'Summary',
	DESCRIPTION: 'Description',
	EVINCED_KNOWLEDGE_BASE_URL: 'Evinced Knowledge Base URL',
	KNOWLEDGE_BASE_LINKS: 'Knowledge Base Links',
	COMPONENT_ID: 'Component ID',
	COMPONENT: 'Component',
	SELECTOR: 'Selector',
	HTML_SNIPPET: 'HTML Snippet',
	URL: 'URL',
	PAGE_TITLE: 'Page Title',
	NOTE: 'Note'
};
export const LABELS = {
	DOWNLOAD_CSV: 'Download CSV'
};
